import Handlebars from 'handlebars/dist/cjs/handlebars';

// Handlebars helpers
Handlebars.registerHelper('inc', value => parseInt(value, 2) + 1);

Handlebars.registerHelper('toLocaleString', number => {
  if (!number) return null;
  return number.toLocaleString('en-IN', { minimumFractionDigits: 2 });
});

Handlebars.registerHelper('checkPincode', value => {
  if (value === '' || value || value === undefined) {
    return true;
  } else {
    return /^20{1}|21{1}|22{1}|23{1}|24{1}|25{1}|26{1}|27{1}|28{1}/.test(value);
  }
});

Handlebars.registerHelper('getCGST', (tax, items) => {
  const withoutTax = items.reduce((subTotal, item) => subTotal + item.amount, 0);
  const withTax = (withoutTax * tax) / 100;
  return withTax / 2;
});
Handlebars.registerHelper('getSGST', (tax, items, total) => {
  const withoutTax = items.reduce((subTotal, item) => subTotal + item.amount, 0);
  const CGST = (withoutTax * tax) / 100 / 2;
  return total - withoutTax - CGST;
});

Handlebars.registerHelper('getSubTotal', value =>
  value.reduce((subTotal, item) => subTotal + item.amount, 0)
);
Handlebars.registerHelper('getTax', value => value / 2);
Handlebars.registerHelper('getTaxAmount', (tax, items) => {
  const withoutTax = items.reduce((subTotal, item) => subTotal + item.amount, 0);
  return (withoutTax * tax) / 100;
});
Handlebars.registerHelper('getCycles', value => (value === 0 ? 'Never Expires' : value));
